import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import ThreadList from '@components/threadList';
import UserPostList from '@components/userPostList';
import { copy } from '@utils/copy';
import Avatar from '@components/avatar';
import { BASE_IMG_URL } from '@images/imageUrls';
import Toast from '@components/Toast';
import TabNav  from '@components/tabNav';
import { px2rem } from '@utils/px2rem';
import CommonSharePopup from "@components/commonSharePopup";
import classNames from 'classnames';
import updateImageListSrc from "@utils/update-image-list-src";

interface RouteParams {
    code?: string;
}
interface UserH5PageProps extends BasePageProps, RouteComponentProps<RouteParams> {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    userInfo?: any
    userMedalData?: any
    createFollowUser?: any
    followDelete?: any
    handleLoadMore: any
    navList?: any
    navClick?: Function
    navCurrentIndex?: any
    navCurrentType?: any
    postsList?: any   //评论列表
    openDialog?: any
}
interface UserH5State {
    loading: boolean;
    error: any
    pageLoaded: any
    topicList: any
    menuDropStatus: boolean
    sharePopupStatus: boolean
    // navList: any
}
@inject('app', 'site', 'user', 'thread')
@observer
class UserH5Page extends BasePage<UserH5PageProps, UserH5State> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        topicList: [],
        menuDropStatus: false,  // 退出登录下拉框
        sharePopupStatus: false,    // 分享弹框是否显示
        // navList: [
        //     {name: '发帖', id: 0, type: '0'},
        //     // {name: '评论', id: 0, postCount: '1'},
        //     // {name: '点赞', id: 1, postCount: '2'},
        //     // {name: '收藏', id: 0, postCount: '1'},
        //     // {name: '勋章', id: 1, postCount: '2'},
        // ],  // tab切换列表
    };
    componentDidMount() {
        const { app, user, thread } = this.props;
        // if (user) {
        //     user.fetchUserInfo({ code: user?.userInfo?.code });
        // }
        // if(thread) {
        //     let params:any = {
        //         "page[number]": 1,
        //         "page[size]": 20
        //     }
        //     thread.getThreadList(params)
        // }
        super.componentDidMount();
    }

    // 跳转到帖子详情页
    // handleThreadClick = (id: string | number) => {
    //     this.props.history && this.props.history.push(`/threadDeatil/${id}`);
    // };

    // 点击复制
    onCopyClick = (data) => {
        copy(data);
        Toast.success({ content: '已复制社区号' });
    }

    // 处理导航点击
    handleNavClick = (item: any, index: number) => {
        // 调用父组件传递的函数
        const { navClick } = this.props;
        if (navClick) {
            navClick(item, index);
        }
    }


    // 帖子列表
    renderThreadList = () => {
        const { user, handleLoadMore, navCurrentType } = this.props;
        if (!user || !user.listStore) return null;
        const list = user.listStore.lists['usersThreadsList'];
        if (!list) return null;
        const flatList = user.listStore.getList({ namespace: 'usersThreadsList' });
        let isSelf = this.props.match.params?.code == user?.userInfo?.code ? true : false; // 是否是自己
        return (
            <div style={{ marginBottom: 16 }}>
                <ThreadList
                    data={flatList}  
                    namespace="usersThreadsList"
                    emptyBoxStyle={{ padding: `${px2rem(200)} 0 ${px2rem(500)}`}}
                    isSelf={isSelf}
                    showThreadStatus={navCurrentType == 0 ? true : false}
                    onLoadMore={handleLoadMore}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    listStore={user.listStore}
                ></ThreadList>
                {/*   */}
            </div>
        )
    }

    // 评论列表
    renderPostList = () => {
        const { user, handleLoadMore } = this.props;
        if (!user || !user.listStore) return null;
        const list = user.listStore.lists['usersPostsList'];
        if (!list) return null;
        const flatList = user.listStore.getList({ namespace: 'usersPostsList' });
        return (
            <div style={{ marginBottom: 16 }}>
                <UserPostList
                    data={flatList}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={{ padding: '200px 0 500px' }}
                    namespace="usersPostsList"
                    onLoadMore={handleLoadMore}
                    listStore={user.listStore}></UserPostList>

            </div>
        )
    }

    // 点赞列表
    renderLikesList = () => {
        const { user, handleLoadMore } = this.props;
        if (!user || !user.listStore) {
            return null;
        }
        const list = user.listStore.lists['usersLikesList'];
        if (!list) {
            return null;
        }
        const flatList = user.listStore.getList({ namespace: 'usersLikesList' });
        return (
            <div style={{ marginBottom: 16 }}>
                <ThreadList
                    data={flatList}  
                    namespace="usersLikesList"
                    emptyBoxStyle={{ padding: `${px2rem(200)} 0 ${px2rem(500)}`}}
                    onLoadMore={handleLoadMore}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    listStore={user.listStore}
                ></ThreadList>
            </div>
        )
    }

    // 收藏列表
    renderFavoritesList = () => {
        const { user, handleLoadMore } = this.props;
        if (!user || !user.listStore) {
            return null;
        }
        const list = user.listStore.lists['usersFavoritesList'];
        if (!list) {
            return null;
        }
        const flatList = user.listStore.getList({ namespace: 'usersFavoritesList' });
        return (
            <div style={{ marginBottom: 16 }}>
                <ThreadList
                    data={flatList}  
                    namespace="usersFavoritesList"
                    emptyBoxStyle={{ padding: `${px2rem(200)} 0 ${px2rem(500)}`}}
                    onLoadMore={handleLoadMore}
                    emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                    listStore={user.listStore}
                ></ThreadList>
            </div>
        )
    }

    // 关闭弹框
    onHidePopup = () => {
        console.log('关闭');
        this.setState({
            sharePopupStatus: false,
        })
    }

    render() {
        let { menuDropStatus, sharePopupStatus } = this.state;
        const { user, userInfo, userMedalData, navList, createFollowUser, followDelete, match, navCurrentIndex, openDialog } = this.props;
        let isSelf = match.params?.code == user?.userInfo?.code ? true : false; // 是否是自己
        const displayNavList = isSelf ? navList : (navList || []).filter((item: any) => item?.namespace !== 'usersFavoritesList');
        const displayNavCurrentIndex = displayNavList[navCurrentIndex] ? navCurrentIndex : 0;
        const isProdEnv = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';
        return ( <div className={styles.wrapper}>
            <div className={styles.userDetail}>
                {/* 用户头像背景 */}
                <div className={styles.userBgBox}>
                    <img src={updateImageListSrc(userInfo?.backgroundUrl, 20) || `${BASE_IMG_URL}/common/user_bg3.png`} alt="头像背景" className={styles.userBg}/>
                    {isSelf && <div className={styles.userSettingBox}>
                        <img src={`${BASE_IMG_URL}/common/setting.png`} alt="分享" className={styles.settingIcon} onClick={() => {
                            this.setState({
                                menuDropStatus: !menuDropStatus
                            })
                        }} />
                        {menuDropStatus && <div className={styles.menuDropListBox}>
                            <div className={styles.menuDropItem} onClick={async () => {
                                this.setState({ menuDropStatus: false });
                                
                                if (this.props.user) {
                                    await this.props.user.logoutRemote();
                                }
                            }}>退出登录</div>
                        </div>}
                    </div>}
                    <div className={styles.userTopRight}>
                        {isSelf && <div className={styles.messageBox} onClick={() => {
                            this.props.history.push(`/message/${user?.userInfo?.code}`); 
                        }}>
                            <div className={styles.icon}></div>
                            {user.userMeta?.unreadCount > 0 && <div className={styles.num}>{user.userMeta?.unreadCount > 99 ? '99+' : user.userMeta?.unreadCount}</div>}
                        </div>}
                        <img src={`${BASE_IMG_URL}/common/share2.png`} alt="分享" className={styles.shareIcon} onClick={() => {
                            this.setState({
                                sharePopupStatus: true
                            })
                        }} />
                    </div>
                    
                </div>

                {/* 用户信息 */}
                <div className={styles.userInfoBox}>
                    <div className={styles.avatarBox}>
                        <Avatar avatarUrl={userInfo?.avatarUrl || ''} size={146} userCode={userInfo?.code} titleMark={userInfo?.titleMark} level={userInfo?.level} officialSize={32}></Avatar>
                    </div>
                    
                    <div className={styles.userInfoDetail}>
                        <div className={styles.nickname}>
                            {userInfo?.nickname}
                            {userInfo?.gender === 2 && <img src={`${BASE_IMG_URL}/common/woman.png`} alt="性别" className={styles.gender}/>}
                            {userInfo?.gender === 1 && <img src={`${BASE_IMG_URL}/common/man.png`} alt="性别" className={styles.gender}/>}
                        </div>
                        <div className={styles.info}>
                            {userInfo?.lastPublishSource !== '' && <span className={styles.model}>{userInfo?.lastPublishSource}</span>}
                            <span className={styles.userId} onClick={() => this.onCopyClick(userInfo?.code)}>社区号  {userInfo?.code}</span>
                        </div> 
                    </div>
  
                </div>
                <div className={styles.titleBox}>
                    {/* 如果是个人，不限制头衔数量；如果是他人中心，展示两个头衔，因为右侧要显示关注和私信 */}
                    {userInfo?.titleList?.length > 0 && <div className={styles.userTags}>
                        {userInfo?.titleList?.slice(0, 2).map((tag) => <div className={classNames(styles.tag, tag.wear ? styles.tagActive : '')}>{tag.title_name}</div>)}
                        <div className={styles.totalTags}>共{ userInfo?.titleList?.length }个头衔</div>
                        {/* {(userInfo?.titleList?.length > 2 && !isSelf) && <span className={styles.tagMore}>更多头衔</span>} */}
                    </div>}
                    {(!userInfo?.titleList || userInfo?.titleList?.length == 0) && <div className={styles.info3}>暂无头衔</div>}
                    {!isSelf && <div className={styles.userRightBox}>
                        <div className={styles.message} onClick={() => window.globalEnsureLogin(openDialog())}>私信</div>
                        {(userInfo?.follow === 0 || !userInfo?.follow) && <div className={styles.follow} onClick={()=>window.globalEnsureLogin(createFollowUser)}>关注</div>}
                        {(userInfo?.follow === 1 ||  userInfo?.follow === 2) && <div className={styles.followed} onClick={()=>window.globalEnsureLogin(followDelete)}>已关注</div>}
                    </div>}
                    
                </div>
                <div className={styles.info2}>{userInfo?.signature || '欢迎来到vivo社区，快来介绍下自己吧~'}</div>
                <div className={styles.userNumBox}>
                    <div className={styles.numItem}>
                        <div className={styles.num}>{userInfo?.getLikedCount}</div>
                        <div className={styles.text}>获赞</div>
                    </div>
                    <div className={styles.numItem}>
                        <div className={styles.num}>{userInfo?.followCount}</div>
                        <div className={styles.text}>关注</div>
                    </div>
                    <div className={styles.numItem}>
                        <div className={styles.num}>{userInfo?.fansCount}</div>
                        <div className={styles.text}>粉丝</div>
                    </div>
                    {isSelf && <div className={styles.numItem} onClick={() => this.props.history.push('/vCoinRecord')}>
                        <div className={styles.num}>{userInfo?.score}</div>
                        <div className={styles.text}>V币</div>
                    </div>}
                </div>
                <div className={styles.outerBox}>
                    {userMedalData?.userGotMedal?.length > 0 && <div className={styles.medalListBox}>
                        <div className={styles.medalTitleBox}>
                            <div className={styles.title}>{isSelf ? '我' : 'TA'}的勋章</div>
                            {/* <img src={`${BASE_IMG_URL}/common/arrow_r2.png`} alt="" className={styles.medalMore}/> */}
                        </div>
                        <div className={styles.medalContentBox}>
                            <div className={styles.medalList}>
                                {userMedalData?.userGotMedal?.map((item:any) => 
                                    <div className={styles.medalItem}>
                                        {item?.is_show && <img src={`${BASE_IMG_URL}/common/wear.png`} alt="" className={styles.medalWear}/>}
                                        <img src={item?.medals?.light_pic} alt="" className={styles.medal}/>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>}
                    <div className={styles.tabBgBox}>
                        <TabNav navList={displayNavList} currentIndex={displayNavCurrentIndex} isAlignLeft={true} navClick={(item:any, index:any) => this.handleNavClick(item, index)}></TabNav>           
                    </div>
                    {displayNavCurrentIndex == 0  && this.renderThreadList()}
                    {displayNavCurrentIndex == 1  && this.renderPostList()}
                    {displayNavCurrentIndex == 2  && this.renderLikesList()}
                    {isSelf && displayNavCurrentIndex == 3  && this.renderFavoritesList()}
                </div>  
            </div>
            {/* 分享弹框 */}
            <CommonSharePopup
                visible={sharePopupStatus}
                title="分享"
                copyText={isProdEnv ? `「${userInfo.nickname}」的个人主页，${userInfo.signature + '~' || '保持热爱，遇见更多有趣的人和事~'}\r\nhttps://club.vivo.com.cn/user/${userInfo?.code}，\r\n复制本消息打开vivo社区App即可直达个人主页~` : `「${userInfo.nickname}」的个人主页，${userInfo.signature + '~' || '保持热爱，遇见更多有趣的人和事~'}\r\nhttps://club.vivo.com.cn/user/${userInfo?.code}，\r\n复制本消息打开vivo社区App即可直达个人主页~`}
                copyToastText='链接复制成功，快去分享好友吧～'
                copyLink={() => this.onHidePopup()}
                onCancelChange={() => this.onHidePopup()}
            >
            </CommonSharePopup>
        </div>) 
    }
}

export default withRouter(UserH5Page);
